import { DefaultService } from '@/services/DefaultService';

export default class VendasRelPeriodoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    loadItens(page = 0, limit = 15, filtros) {
        return this._http.post(`${this._env}/report/pivot/relatoriovendasperiodo.json?page=${page}&limit=${limit}`, filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}